import { render, staticRenderFns } from "./Lgx240135806843355136.vue?vue&type=template&id=8ec6065c&scoped=true&"
import script from "./Lgx240135806843355136.vue?vue&type=script&lang=js&"
export * from "./Lgx240135806843355136.vue?vue&type=script&lang=js&"
import style0 from "./Lgx240135806843355136.vue?vue&type=style&index=0&id=8ec6065c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec6065c",
  null
  
)

export default component.exports